angular.module('components.caOrderArticleRows', [])
    .component('caOrderArticleRows', {
        templateUrl: 'main/order/ordersearch/components/orderarticlerows.component.tpl.html',
        controllerAs: 'vm',
        bindings: {
            orderArticle: '<',
            order: '<'
        },
        controller: controller
    });

// @ngInject
function controller($translate) {
    var vm = this;

    //Properties
    var flexGrid = {};
    var rowData = [];
    var rowCollection = new wijmo.collections.CollectionView(rowData);
    var articleVariants = [];

    //Methods
    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.$onDestroy = onDestroy;
    vm.gridPostInitialization = gridPostInitialization;

    function onInit() {
    }
    function onChanges(changes) {
        if (changes.orderArticle &&
            changes.orderArticle.currentValue &&
            changes.orderArticle.currentValue !== changes.orderArticle.previousValue) {
            if (!changes.orderArticle.previousValue ||
                changes.orderArticle.currentValue.id !== changes.orderArticle.previousValue.id) {
                flexGrid = {};
                rowData = [];
                rowCollection = new wijmo.collections.CollectionView(rowData);
                articleVariants = [];

                vm.flexGridData = { destinations: [{locationName: (vm.order.destination) ? vm.order.destination.locationName : vm.order.fromLocation.locationName}] };

                _.forEach(vm.orderArticle.orderRows, function(orderRow) {
                    if (!orderRow.summarizedDeliveredQuantity) { orderRow.summarizedDeliveredQuantity = 0; }
                    orderRow.summarizedDeliveredQuantity = orderRow.deliveryRows && orderRow.deliveryRows.length > 0 ? _.sumBy(orderRow.deliveryRows, function(dr) {
                        return dr.systemStatus.toLowerCase() === 'delivered' && dr.deliveryRowType === 'deliveryIn' ? dr.quantity : 0;
                    }) : 0;
                    orderRow.articleVariant.summarizedDeliveredQuantity = orderRow.summarizedDeliveredQuantity;

                    if (!orderRow.summarizedOutdeliveredQuantity) { orderRow.summarizedOutdeliveredQuantity = 0; }
                    orderRow.summarizedOutdeliveredQuantity = orderRow.deliveryRows && orderRow.deliveryRows.length > 0 ? _.sumBy(orderRow.deliveryRows, function(dr) {
                        return dr.systemStatus.toLowerCase() === 'delivered' && dr.deliveryRowType === 'deliveryOut' ? dr.quantity : 0;
                    }) : 0;
                    orderRow.articleVariant.summarizedOutdeliveredQuantity = orderRow.summarizedOutdeliveredQuantity;

                    orderRow.articleVariant.quantity = orderRow.quantity;
                    articleVariants.push(orderRow.articleVariant);
                });
            }
        }
    }
    function onDestroy() {

    }

    function gridPostInitialization(sender, e, locationName) {
        flexGrid = sender;
        flexGrid.initialize({
            autoGenerateColumns: false,
            selectionMode: wijmo.grid.SelectionMode.Row,
            allowDragging: wijmo.grid.AllowDragging.None,
            allowResizing: wijmo.grid.AllowResizing.Columns,
            frozenColumns: 2,
            itemsSource: rowCollection
        });

        setupGrid();
        loadGridData('Quantity');
    }

    function setupGrid() {
        rowData.length = 0;
        flexGrid.finishEditing(true);
        flexGrid.columns.clear();
        flexGrid.invalidate();
        rowCollection.refresh();
        initializeGridColumns();
    }

    function initializeGridColumns() {
        // Add first row header column
        var rowHeader = new wijmo.grid.Column();
        rowHeader.binding = "variantDetails1Name";
        rowHeader.header = ' ';
        rowHeader.allowSorting = false;
        rowHeader.allowResizing = true;
        rowHeader.width = 200;
        rowHeader.minWidth = 100;
        rowHeader.isReadOnly = true;
        flexGrid.columns.push(rowHeader);

        var columns = getDataColumns();

        if (columns.length > 1) {
            var rowTotal = new wijmo.grid.Column();
            rowTotal.binding = "rowTotalString";
            rowTotal.header = $translate.instant('customerorder.totalquantity');
            rowTotal.allowSorting = false;
            rowTotal.allowResizing = true;
            rowTotal.width = 100;
            rowTotal.minWidth = 100;
            rowTotal.isReadOnly = true;
            rowTotal.align = "right";
            flexGrid.columns.push(rowTotal);
        }

        // Add dynamic columns
        _.forEach(columns, function (variantDetail) {
            var c = new wijmo.grid.Column();
            c.binding = variantDetail.variantDetailName;
            c.header = variantDetail.variantDetailName;
            c.width = '*';
            c.minWidth = 100;
            c.allowSorting = false;
            c.allowResizing = true;
            c.inputType = 'text';
            c.isReadOnly = true;
            c.align = "right";
            flexGrid.columns.push(c);
        });
    }

    function getDataColumns() {
        var columns = [];

        // Group by nested variantDetail2 in the current articleVariants
        columns = _.groupBy(articleVariants, function(variant) {
            return variant.variantDetail2.variantDetailName;
        });
        // Get the variantDetail2 from each group in an array
        columns = _.reduce(columns, function(newArray, val, key) {
            newArray.push(val[0].variantDetail2);
            return newArray;
        }, []);

        return _.sortBy(columns, 'sortOrder');
    }

    function loadGridData(type) {
        var variantRows = _.groupBy(articleVariants, function(variant) {
            return variant.variantDetail1.id;
        });
        _.forEach(variantRows, function(variantRowValues) {
            var r = {
                rowTotal: 0,
                rowTotalDeliveredQuantity: 0,
                rowTotalString: ''
            };
            _.forEach(variantRowValues, function(variantRowValue) {
                r.variantDetails1Name = variantRowValue.variantDetail1.variantDetailName;

                r.variantExternalId = variantRowValue.externalId;

                var deliveredQuantity = variantRowValue.summarizedDeliveredQuantity;
                if (vm.order.orderType.orderSystemType === 'return') { deliveredQuantity = Math.abs(variantRowValue.summarizedOutdeliveredQuantity); }
                r.rowTotalDeliveredQuantity += deliveredQuantity;

                r[variantRowValue.variantDetail2.variantDetailName] =
                    variantRowValue['quantity'].toString() + " (" + deliveredQuantity + ")";

                r.rowTotal += variantRowValue['quantity'];
            });
            r.rowTotalString = r.rowTotal.toString() + ' (' + r.rowTotalDeliveredQuantity.toString() + ')';
            rowData.push(r);
        });
        rowCollection.refresh();
    }
}
